
import { useStore } from '@/store'
import { reactive, defineComponent, toRefs, onMounted } from 'vue'
import Account from './components/Account.vue'
import Activity from './components/Activity.vue'
import Timeline from './components/Timeline.vue'
import UserCard from './components/UserCard.vue'
 interface Profile {
  name: string
  roles: string
}
export default defineComponent({
  components: {
    Account,
    Activity,
    Timeline,
    UserCard
  },
  setup() {
    const defaultProfile: Profile = {
      name: 'Yours Extra.',
      roles: 'Loading...'
    }
    const store = useStore()
    const dataMap = reactive({

      user: defaultProfile,
      activeTab: 'activity',

      name: () => {
        return store.state.user.info?.username
      },
      roles() {
        return store.state.user.roles
      },
      getUser: () => {
        dataMap.user = {
          name: dataMap.name() || '',
          roles: dataMap.roles().join(' | ')
        }
      }

    })

    onMounted(() => {
      dataMap.getUser()
    })

    return { ...toRefs(dataMap) }
  }
})
